import React, { HTMLAttributes } from 'react';
import { makeStyles, createStyles } from '@material-ui/core';
import { ExtendedTheme } from 'neon-design-system';

type CardProps = HTMLAttributes<HTMLDivElement>;

const useStyles = makeStyles<ExtendedTheme>(theme => createStyles({
	root: {
		padding: theme.spacing(2),
		backgroundColor: theme.palette.grey[800],
		display: 'flex',
		flexDirection: 'column',
		borderRadius: '4px',
		height: '100%',
		[theme.breakpoints.up('md')]: {
			padding: theme.spacing(3)
		}
	}
}));


const Card = ({ children, className, ...divProps }: CardProps) => {
	const classes = useStyles();

	return (
		<div
			{...divProps}
			className={[classes.root, className].filter(Boolean).join(' ')}>
			{children}
		</div>
	)
}

export default Card;
